module.exports = __webpack_public_path__ + "static/desktops-c25c9a83d4720250a48439d0e79bc3f9.png";